module.exports = __webpack_public_path__ + "img/content-not-found-dark.6eace3d.svg";